/* ═══════════════════════════════════════════════════
   NEWJAISA — CASE STUDIES HUB & DETAIL
   File: assets/component-case-studies.js
   Namespace: CaseStudies · No globals · No jQuery
   No inline onclick — all addEventListener
═══════════════════════════════════════════════════ */

'use strict';

var CaseStudies = (function () {

  function $(id)   { return document.getElementById(id); }
  function $$(sel) { return Array.from(document.querySelectorAll(sel)); }

  var currentStudy = null;

  /* ══════════════════════════════════════════════════
     CASE STUDY DATA
  ══════════════════════════════════════════════════ */
  var STUDIES = [
    {
      id:            'mdg',
      company:       'MedGenome',
      logo:          'MG',
      subtitle:      'Healthcare · Genomic Labs · Pune · Delhi · Bengaluru',
      industry:      'healthcare',
      industryLabel: 'Healthcare & Genomics Labs · Pan-India',
      pill:          'Monthly Procurement · New Hardware · 3 Locations · OEM-BEating Value',
      tags:          ['Monthly Procurement', 'New Hardware', '3 Locations', 'OEM-Beating Value'],
      desc:          'MedGenome, a leader in genomics-driven healthcare solutions, required a vendor they could genuinely trust — one who could meet the exacting specification standards of a healthcare environment, deliver new hardware consistently across three cities, and offer pricing that outperformed OEMs. After a thorough, detail-heavy evaluation process, they found their answer in NewJaisa. The partnership started with 50 units, is on track for a 900-unit pipeline, and grows every single month.',
      metrics: [
        { num: '50',       lbl: 'Phase 1 Unit Deployed', cls: '' },
        { num: '900',  lbl: 'Units in Pipeline',   cls: '' },
        { num: '3',        lbl: 'Cities Supported',           cls: 'green' },
        { num: 'Monthly',  lbl: 'OnGoing Procurement',  cls: 'green' },
        { num: 'Better', lbl: 'Than OEM in Pricing/Support',       cls: 'yellow' },
      ],
      challenge: [
        'MedGenome operates in a highly regulated healthcare environment, hardware quality and specification compliance were non-negotiable, with zero tolerance for under-spec devices.',
        'Previous vendor conversations lacked the depth and technical seriousness MedGenome required, most couldn\'t sustain a detailed, spec-by-spec procurement dialogue.',
        'Coordinating hardware procurement across three geographically spread offices (Pune, Delhi, Bangalore) with no unified vendor created logistical friction and inconsistent delivery.',
        'OEM pricing and support structures were costly and inflexible, MedGenome needed the same quality standard at better commercial terms.',
        'They needed a vendor with genuine market trust, not an experiment, but a long-term partner they could rely on as their employee base scaled.',
      ],
      solution: [
        'Engaged in a thorough, spec-driven procurement consultation — matching hardware configurations precisely to MedGenome\'s clinical, genomics, and operational workloads.',
        'Supplied new hardware (not refurbished) to meet MedGenome\'s healthcare-grade procurement policy, with full documentation and warranty coverage.',
        'Established a unified, single-vendor supply model covering all three locations — Pune, Delhi, and Bangalore — with consistent specifications and delivery SLAs.',
        'Delivered pricing that beat OEM rates without compromising on hardware grade, enabling meaningful cost optimisation across the fleet.',
        'Built an optimised, recurring monthly procurement model — ensuring MedGenome can onboard new employees smoothly without procurement bottlenecks.',
      ],
      outcomes: [
        '50 units deployed in Phase 1 across Pune, Delhi and Bangalore — delivered on spec without a single quality escalation.',
        'Monthly procurement rhythm established — MedGenome\'s IT team no longer manages ad-hoc purchase cycles. Hardware flows as employees join.',
        '900-unit pipeline secured — MedGenome\'s long-term scaling plan is now fully anchored to NewJaisa as the trusted IT hardware partner.',
        'Hardware pricing that beat OEM rates — significant cost optimisation on every procurement cycle without compromising on new-hardware grade.',
        'Three-city coordination consolidated into a single-vendor model — consistent specs and SLAs across Bangalore, Delhi, and Pune with one call.',
        'Proven satisfaction — MedGenome is actively expanding the relationship from entry-level to mid-level employee hardware, reflecting deep trust in NewJaisa\'s delivery.',
      ],
      quote:     '"We did our due diligence — the spec conversations were detailed and lengthy. NewJaisa was the only vendor who could match both our technical requirements and our commercial expectations. The trust was earned, not assumed."',
      quoteName: 'Head of Procurement — MedGenome',
      quoteRole: 'Healthcare & Genomics Operations · Pan-India Operations',
      ctaMsg:    'Want results like ?',
    },

        {
      id:            'mtphlt',
      company:       'Metropolis Healthcare',
      logo:          'M',
      subtitle:      'Healthcare Diagnostics · Pan-India',
      industry:      'healthcare',
      industryLabel: 'Diagnostics & Healthcare · Pan-India',
      pill:          '📖 Case Study · Healthcare · ESG Compliance',
      tags:          ['100% Remote Closure', 'ESG Compliance', 'ISO & R2 Certified', 'NSE Credibility'],
      desc:          'Metropolis had been buying refurbished IT but faced repeated post-sale support failures. NewJaisa deployed 500 workstations across Mumbai, Bangalore, Pune, Chennai, and Kolkata — with on-site support teams and full model-level traceability at every location.',
      metrics: [
        { num: '100%',       lbl: 'Remote contract closure', cls: '' },
        { num: '5',  lbl: 'Cities Covered',   cls: '' },
        { num: '0',        lbl: 'UnSolved Tickets',           cls: 'green' },
        { num: 'ISO & R2',  lbl: 'Documentation delivered',  cls: 'green' },
        { num: 'NSE Listed', lbl: 'Vendor credibility',       cls: 'yellow' },
      ],
      challenge: [
        'Metropolis had been purchasing refurbished IT equipment but faced consistent post-sale support failures — vendors were unreachable after delivery.',
        'No vendor could offer on-site support across multiple cities simultaneously, leaving technicians to manage hardware issues in-house.',
        'Generic, untracked hardware from previous vendors made warranty claims and part replacements nearly impossible to manage.',
        '500 workstations needed to be deployed across Mumbai, Bangalore, Pune, Chennai, and Kolkata — a logistics challenge no local vendor had tackled at this scale.',
        'Lack of structured documentation and model-level records created compliance and audit risks in a regulated healthcare environment.',
      ],
      solution: [
        'Deployed dedicated on-site support teams in all 5 cities, ensuring same-day or next-day resolution for any hardware issue post-deployment.',
        'Assigned unique, traceable model numbers to every device — enabling Metropolis to raise support tickets with full hardware context and history.',
        'Coordinated a phased pan-India rollout with city-specific logistics teams ensuring zero delivery conflicts and on-time installation at each site.',
        'Provided a 1-year device warranty with documented SLAs, giving Metropolis full operational confidence and audit-ready compliance records.',
        'Configured every workstation to Metropolis\'s exact diagnostic software and OS specifications, with standardised imaging across all 100 units.',
      ],
      outcomes: [
        '100 workstations deployed across Mumbai, Bangalore, Pune, Chennai, and Kolkata — all on time, fully configured, and ready for immediate use on day one.',
        'Metropolis finally moved away from unreliable post-sale vendors — establishing a structured, long-term IT partnership backed by SLA commitments and real accountability.',
        '1-year device warranty provided complete long-term operational peace of mind — every workstation protected with documented SLA-backed coverage across all sites.',
        'Zero unresolved support tickets across all five cities — dedicated on-site NewJaisa teams ensured same-day or next-day resolution for every hardware issue.',
        'Dedicated model numbers on every device gave Metropolis complete hardware traceability — enabling audit-ready compliance records across all diagnostic locations.',
        'All 100 workstations configured to Metropolis\'s exact diagnostic software and OS image — eliminating compatibility issues and standardising operations across every city branch.',
      ],
      quote:     '"We had been burned by vendors who disappeared after delivery. NewJaisa was different — they had teams on the ground in every city we operate in, and every device came with a model number we could actually track. For a healthcare network like ours, that level of accountability is non-negotiable."',
      quoteName: 'Head of IT Infrastructure — Metropolis Healthcare',
      quoteRole: 'Diagnostics & Healthcare · Pan-India Operations',
      ctaMsg:    'Want results like ?',
    },
    {
      id:            'resultscx',
      company:       'ResultsCX',
      logo:          'R',
      subtitle:      'BPO & Call Centers · Pan-India',
      industry:      'bpo',
      industryLabel: 'BPO & Call Centers',
      pill:          '📖 Case Study · BPO & Call Centers',
      tags:          ['Rapid Deployment', '1,000 Seats', 'SLA-Backed'],
      desc:          'A phase-wise 1,000-seat BPO deployment with a strict 15-day deadline for the first 200 seats. Previous vendors had failed. NewJaisa delivered on time, on spec, with zero downtime on go-live.',
      metrics: [
        { num: '1,000',  lbl: 'Seats deployed',             cls: '' },
        { num: '15 days',lbl: 'First 200 seats delivered',  cls: '' },
        { num: '₹2.4 Cr',lbl: 'Total cost saved',           cls: 'green' },
        { num: '0',      lbl: 'Downtime on go-live',         cls: 'green' },
        { num: '3 yrs',  lbl: 'Warranty provided',           cls: 'yellow' },
      ],
      challenge: [
        'Phase-wise launch from 100 to 1,000 seats required with strict go-live timelines',
        'First 200 seats needed on-site within 15 days — previous vendors had failed to deliver',
        'Lack of large-scale refurbished IT supply and local support capability in market',
        'Multiple delays and broken promises from previous hardware vendors had cost the client',
        'No trusted partner with SLA-backed delivery and compliance documentation available',
      ],
      solution: [
        'Delivered the first lot of 200 seats on-site within the 15-day deadline, fully configured',
        'Aligned a dedicated account manager and support team for priority resolution and zero-delay go-live',
        'Assisted in scaling the project phase-by-phase at the required pace up to 1,000 total seats',
        'Provided 3 years of warranty per device for complete long-term operational peace of mind',
        'Customised every device configuration based on ResultsCX\'s exact specification and OS image',
        'Enabled full on-site installation and agent-level testing before go-live day',
      ],
      outcomes: [
        'The project launched on time — zero delays on go-live day across all deployed seats',
        'Zero downtime reported during the go-live phase across the entire 200-seat first batch',
        'Positive client feedback elevated NewJaisa to preferred long-term refurbishment partner',
        'ResultsCX can now scale rapidly with predictable refresh and maintenance costs',
        'Operations are future-proof for 3–5 years with structured device warranties in place',
        'Total cost saved across the full project: approximately ₹2.4 Crores vs buying new hardware',
      ],
      quote:     '"NewJaisa became our go-to partner for every rapid deployment need. When we needed 1,000 seats done right and done fast, they were the only vendor who delivered without excuses."',
      quoteName: 'IT Procurement Head',
      quoteRole: 'Operations Director · ResultsCX India',
      ctaMsg:    'Want results like ResultsCX?',
    },
    {
      id:            'fives',
      company:       'FiveS Digital',
      logo:          '5',
      subtitle:      'BPO Startup · OpEx Leasing · Pan-India',
      industry:      'bpo',
      industryLabel: 'BPO / Startup Scale-Up',
      pill:          '📖 Case Study · BPO · Startup Scale-Up',
      tags:          ['Siemens Lease', 'India First', '500 Seats', '₹0 CapEx'],
      desc:          'FiveS Digital needed 500 seats on lease with zero upfront CapEx. No Indian vendor had ever structured a refurbished IT lease at scale. NewJaisa partnered with Siemens Financial Services to create India\'s first.',
      metrics: [
        { num: '500',        lbl: 'Seats on lease',         cls: '' },
        { num: 'Siemens',    lbl: 'Financing partner',      cls: '' },
        { num: '₹0',         lbl: 'Upfront CapEx',          cls: 'green' },
        { num: 'Multi-city', lbl: 'Deployment coverage',    cls: 'green' },
        { num: 'India First',lbl: 'Refurb IT lease',         cls: 'yellow' },
      ],
      challenge: [
        'Needed 500 assets on an OpEx lease — company did not want to spend any CapEx on hardware',
        'Required a flexible financial model to reduce upfront capital expenditure for a growth-stage company',
        'No leasing infrastructure existed anywhere in India for refurbished IT at this scale',
        'Multi-location deployment was needed across India for their distributed BPO operation',
        'Previous vendors could not offer or structure any financing for refurbished hardware',
      ],
      solution: [
        'NewJaisa pioneered India\'s first large-scale refurbished IT rental by partnering with Siemens Financial Services',
        'Structured a fully SLA-backed lease contract aligned to FiveS\'s growth trajectory and cash flow cycles',
        'Deployed 500 seats on lease with transparent monthly billing — zero upfront hardware CapEx required',
        'Managed multi-location deployment across India with consistent device quality and SLA compliance',
        'Provided high-quality, ready-to-use refurbished systems at highly affordable monthly lease rates',
      ],
      outcomes: [
        '500 seats deployed across multiple locations on a fully structured Siemens-backed lease',
        'FiveS preserved significant working capital and improved operational agility through OpEx model',
        'NewJaisa is now positioned as India\'s first and only large-scale refurb IT lease provider',
        'The deal set a market precedent, influencing broader acceptance of refurb IT leasing nationally',
        'FiveS can now scale hardware up or down at any time without any CapEx risk or write-offs',
        'The Siemens Financial Services partnership created a replicable model for all BPO clients',
      ],
      quote:     '"NewJaisa didn\'t just solve our hardware problem — they solved our financing problem too. The Siemens partnership was the difference-maker. No other vendor in India could offer this."',
      quoteName: 'CFO',
      quoteRole: 'Chief Financial Officer · FiveS Digital',
      ctaMsg:    'Want a lease deal like FiveS Digital?',
    },
    {
      id:            'noise',
      company:       'Noise',
      logo:          'N',
      subtitle:      'Consumer Electronics · Production Team',
      industry:      'startups',
      industryLabel: 'Comsumer Electronics · Warehouse Operations',
      pill:          '📖 Case Study · Tech StartUp · ESG Compliance',
      tags:          ['100% Remote Closure', 'ESG Compliance', '1 Yr Warranty', 'Trusted Vendor'],
      desc:          'Noise needed 50 laptops for their warehouse production team and wanted a vendor they could truly trust. NewJaisa delivered uniform, fully-tested hardware with a 1-year warranty and dedicated account support.',
      metrics: [
        { num: '100%',       lbl: 'Remote contract closure', cls: '' },
        { num: '50',  lbl: 'Laptop Deployed',   cls: '' },
        { num: '0',        lbl: 'Unresolved Issues',           cls: 'green' },
        { num: 'ISO & R2',  lbl: 'Documentation delivered',  cls: 'green' },
        { num: 'NSE Listed', lbl: 'Vendor credibility',       cls: 'yellow' },
      ],
      challenge: [
        'Noises warehouse production team required 50 dedicated laptops to manage daily operations — with no compromise on reliability or uptime.',
        'The market was saturated with unvetted refurbished vendors offering no accountability, no documentation, and no post-sale support.',
        'Noise specifically required a trustworthy, established partner — not a one-time transactional vendor with no long-term commitment.',
        'Warehouse environments demand durable, consistently-specced hardware — generic mixed-lot refurbished machines were not an option.',
        'A clear warranty and support structure was non-negotiable for a team whose productivity depends directly on functioning hardware.',
      ],
      solution: [
        'Supplied 50 uniform, quality-checked refurbished laptops configured to the exact specifications required for Noises production workflow.',
        'Provided a 1-year warranty on every device with documented SLA commitments — giving Noise full confidence in the hardware investment.',
        'Assigned dedicated model numbers to each laptop for complete traceability — enabling fast, accurate support for any device at any time.',
        'Appointed a dedicated account manager as Noises single point of contact for all hardware queries, replacements, and support needs.',
        'Delivered all 50 units on time, fully tested and ready for immediate deployment — zero setup delays on the production floor.',
      ],
      outcomes: [
        'Noises warehouse production team received 50 fully-tested, uniform laptops — deployed with zero downtime on day one.',
        'Noise finally found a trusted, accountable IT vendor — replacing unreliable one-time suppliers with a long-term partnership.',
        'A single dedicated account manager gave Noise one reliable point of contact for all procurement, support, and replacement needs.',
        'Every device covered under a 1-year SLA-backed warranty — giving Noise complete confidence in their hardware investment.',
        'Dedicated model numbers assigned to every laptop — enabling fast, traceable support for any device at any point during the warranty period.',
        'Production team efficiency improved with standardised, spec-consistent hardware across all 50 workstations — no mixed-lot issues.',
      ],
      quote:     '"We have worked with multiple IT vendors before, but none matched the reliability and transparency NewJaisa brought. From day one, every laptop was exactly as promised — and knowing we have a real warranty and a dedicated person to call makes all the difference for our production floor."',
      quoteName: 'Head of Operations — Noise',
      quoteRole: 'Production & Warehouse · Noise India',
      ctaMsg:    'Want results like Noise India?',
    },
    {
      id:            'muthoot',
      company:       'Muthoot Finance',
      logo:          'M',
      subtitle:      'NBFC · 80 Branch Offices · Pan-India',
      industry:      'bfsi',
      industryLabel: 'BFSI / NBFC',
      pill:          '📖 Case Study · BFSI · NBFC · Branch Rollout',
      tags:          ['80+ Branches', '70% CapEx Reduction', 'CAG Docs', 'Pan-India'],
      desc:          'Muthoot Finance needed to refresh hardware across 80+ branch offices simultaneously with full compliance documentation for their CAG audit requirements — at a fraction of new hardware cost.',
      metrics: [
        { num: '80+',      lbl: 'Branches equipped',       cls: '' },
        { num: '70%',      lbl: 'CapEx reduction',          cls: 'green' },
        { num: 'CAG',      lbl: 'Audit docs delivered',     cls: 'green' },
        { num: 'GFR Docs', lbl: 'Full asset register',      cls: 'yellow' },
        { num: 'Pan-India',lbl: 'Simultaneous delivery',    cls: '' },
      ],
      challenge: [
        'Hardware refresh needed simultaneously across 80+ branch offices across multiple Indian states',
        'Full GFR and CAG-compatible audit documentation required per branch for internal and external audits',
        'No single vendor had previously managed a rollout of this scale for an NBFC in India',
        'Branch opening schedules meant staggered delivery was non-negotiable — phased rollout required',
        'ISO & R2 certified documentation issued for all decommissioned hardware, ensuring compliant handling and responsible e-waste disposal.',
      ],
      solution: [
        'Assigned a dedicated project manager for the entire 80+ branch rollout with daily status reporting',
        'Created a branch-wise delivery schedule with real-time consignment tracking per branch location',
        'Per-branch asset registers with ISO & R2 certified documentation delivered digitally across all locations.',
        'Coordinated simultaneous delivery across 80+ locations via 20,000+ pincode delivery network',
        'Old hardware collected, CPCB e-waste certificates issued for environment compliance',
      ],
      outcomes: [
        'Simultaneous rollout across 80+ branches completed on schedule with zero branch opening delays',
        'Per-branch inventory manifests and GFR documentation delivered digitally within 48 hours',
        '70% reduction in hardware CapEx vs buying equivalent new hardware for all 80+ locations',
        'CAG audit passed with all documentation in order — no findings related to IT procurement',
        'Per-branch asset registers with ISO & R2 certified documentation delivered digitally across all locations.',
        'Muthoot Finance named NewJaisa as preferred vendor for all future branch expansion hardware',
      ],
      quote:     '"NewJaisa understood our compliance requirements from day one. The documentation was formatted exactly for our CAG auditors. We\'ve never had an IT procurement this smooth at this scale."',
      quoteName: 'Head of IT Infrastructure',
      quoteRole: 'Muthoot Finance Ltd · NBFC Operations',
      ctaMsg:    'Need a multi-branch rollout?',
    },
  
    //2nd April 2026 for Extra Case Studies
     {
      id:            'chola',
      company:       'Chola MS',
      logo:          'Ch',
      subtitle:      'NBFC · 150+ Branch Offices · Pan-India',
      industry:      'bfsi',
      industryLabel: 'BFSI / NBFC',
      pill:          '📖 Case Study · BFSI · NBFC · Branch Rollout',
      tags:          ['150+ Branches', '65% CapEx Savings', 'RBI Compliant', 'Rapid Delivery'],
      desc:          'Cholamandalam Investment and Finance Company needed a large-scale hardware refresh across 150+ branch offices with full RBI audit documentation and a 3-week deployment window before the financial year close.',
      metrics: [
        { num: '150+',     lbl: 'Branches refreshed',        cls: '' },
        { num: '65%',      lbl: 'CapEx savings vs new',       cls: 'green' },
        { num: '₹1.1 Cr',  lbl: 'Total cost saved',          cls: 'green' },
        { num: '21 days',  lbl: 'End-to-end delivery',        cls: '' },
        { num: 'RBI Docs', lbl: 'Full compliance pack',       cls: 'yellow' },
      ],
      challenge: [
        'Hardware refresh required across 150+ branches in 3 weeks — before financial year closing deadline',
        'RBI-compliant documentation mandatory: per-device ISO & R2 certificates, asset registers, GST invoices',
        'New hardware procurement quote came in at ₹1.7 Cr — rejected by CFO as over-budget',
        'Staggered branch schedules across 12 states made simultaneous delivery and tracking complex',
        'Previous vendors had never managed an NBFC branch rollout with full per-branch audit documentation',
      ],
      solution: [
        '500 Dell OptiPlex SFF and HP ProDesk units confirmed in stock within 48 hours of purchase order',
        'Assigned a dedicated project manager with a branch-wise delivery tracker updated twice daily',
        'Coordinated phased delivery across all 150+ branches via 20,000+ pincode logistics network',
        'Generated per-branch asset registers formatted to RBI audit requirements — delivered digitally within 24 hrs of install',
        'ISO & R2 certified documentation issued for all decommissioned hardware, ensuring compliant handling and responsible e-waste disposal.',
        'All devices pre-configured to Chola\'s standard branch OS image before dispatch — zero setup at branch level',
      ],
      outcomes: [
        'All 150+ branches fully refreshed and operational within the 21-day financial year deadline',
        '₹1.1 Cr saved vs new hardware procurement — entire savings reallocated to branch expansion capex',
        'RBI internal audit cleared with full documentation in order — no IT-related compliance findings',
        'Per-branch asset registers with ISO & R2 certified documentation delivered digitally across all 150+ locations.',
        'Zero branch downtime during the hardware changeover — no customer-facing operations interrupted',
        'Chola MS designated NewJaisa as preferred IT refresh vendor across all future branch projects',
      ],
      quote:     '"The combination of speed, documentation quality and cost savings was unmatched. NewJaisa refreshed 150 branches in 3 weeks — every asset register was RBI-ready on the day of installation. We saved ₹1.1 Crore and hit the year-end deadline."',
      quoteName: 'Head of IT Operations',
      quoteRole: 'Cholamandalam Investment and Finance Company Ltd',
      ctaMsg:    'Need a compliant NBFC branch rollout?',
    },
    {
      id:            'cgs',
      company:       'CGS Inc India',
      logo:          'C',
      subtitle:      'Global BPO · ESG Compliance · Hyderabad',
      industry:      'bpo',
      industryLabel: 'Global BPO / ESG Compliance',
      pill:          '📖 Case Study · Global BPO · ESG Compliance',
      tags:          ['100% Remote Closure', 'ESG Compliance', 'ISO & R2 certified', 'NSE Credibility'],
      desc:          'CGS Inc India needed to establish a Hyderabad BPO operation on certified refurbished IT while satisfying stringent global ESG and compliance policies — and close the entire deal remotely with no physical meetings.',
      metrics: [
        { num: '100%',       lbl: 'Remote contract closure', cls: '' },
        { num: 'Hyderabad',  lbl: 'Multi-site deployment',   cls: '' },
        { num: 'ESG',        lbl: 'Compliance met',           cls: 'green' },
        { num: 'ISO & R2',  lbl: 'Documentation delivered',  cls: 'green' },
        { num: 'NSE Listed', lbl: 'Vendor credibility',       cls: 'yellow' },
      ],
      challenge: [
        'Sought to establish a large Hyderabad operation exclusively on certified refurbished IT assets',
        'Struggling to find a trustworthy Indian vendor with proven track record and SLA-backed delivery',
        'Required ISO, R2 and ESG compliance certifications to satisfy global client procurement policies',
        'CGS\'s international parent clients demanded strict documentation, audits, and compliance verification',
        'The entire deal needed to be closed remotely — no physical meetings possible due to global stakeholders',
      ],
      solution: [
        'Leveraged NSE-listed public company credibility and ISO & R2 certification to build instant trust',
        'Demonstrated digital transparency through comprehensive audit packs, compliance docs, and SLAs',
        'Closed the entire contract remotely — zero physical meetings required at any stage of the deal',
        'Provided a full ESG compliance documentation pack satisfying all stringent global client policies',
        'Delivered on every SLA commitment at the Hyderabad facility from day one of operations',
      ],
      outcomes: [
        'Fully remote contract closure — a first for NewJaisa\'s international enterprise segment',
        'Seamless multi-site implementation at CGS\'s Hyderabad operations with no delays',
        'Strengthened NewJaisa\'s global reputation and entry into international refurb supply chains',
        'Built a foundation for ongoing strategic partnerships with global BPO clients operating in India',
        'Enabled CGS to fully meet stringent ESG and compliance policies from their international parent clients',
        'NSE listing became a key differentiator in enterprise trust-building with international counterparts',
      ],
      quote:     '"The NSE listing and ISO & R2 Certification gave our global compliance team the confidence to close remotely. NewJaisa is the only refurb vendor we trust for international-standard operations."',
      quoteName: 'Country Head — India Operations',
      quoteRole: 'VP Operations · CGS Inc India',
      ctaMsg:    'Want results like CGS Inc India?',
    },
    {
      id:            'ktil',
      company:       'Kaynes Technology India Ltd',
      logo:          'K',
      subtitle:      'Electronics Mfg · Mysuru, Karnataka',
      industry:      'industrial-manufacturing',
      industryLabel: 'Electronics Manufacturing · WFH Scale-Up',
      pill:          '📖 Case Study · Industrial Mfg · ESG Compliance',
      tags:          ['WFH Deployment Type', '1 HQ Support Hub', 'ISO & R2 Certified', 'NSE Credibility'],
      desc:          'Kaynes needed laptops for a distributed WFH workforce with no post-sale support in sight. NewJaisa delivered to their Mysuru HQ and built a centralised repair model — employees send devices to HQ, NewJaisa technicians resolve on-site.',
      metrics: [
        { num: 'WFH',       lbl: 'Deployment Type', cls: '' },
        { num: '1 HQ',  lbl: 'Support Hub',   cls: '' },
        { num: 'ESG',        lbl: 'Compliance met',           cls: 'green' },
        { num: 'ISO & R2',  lbl: 'Documentation delivered',  cls: 'green' },
        { num: 'NSE Listed', lbl: 'Vendor credibility',       cls: 'yellow' },
      ],
      challenge: [
        'Majority of Kaynes employees work from home across multiple locations, making centralised hardware management extremely difficult.',
        'No vendor had offered a reliable, structured solution for delivering and supporting laptops to a distributed remote workforce at scale.',
        'Previous vendors provided hardware with no after-sales support — employees were left stranded when devices failed mid-work.',
        'Lack of a trusted, long-term IT partner meant Kaynes had no dedicated point of contact for procurement or issue escalation.',
        'Sending faulty devices to distant service centres created long downtimes and productivity loss for remote employees',
      ],
      solution: [
        'Delivered all laptops to Kaynes, Mysuru headquarters in a single, fully configured batch — allowing Kaynes to manage last-mile distribution to their employees directly.',
        'Designed a HQ-centric support model: employees ship faulty devices back to HQ, and a dedicated NewJaisa technician visits the Mysuru office to diagnose and resolve all issues on-site.',
        'Assigned dedicated model numbers to every device, ensuring accurate warranty tracking, faster support resolution, and complete hardware traceability.',
        'Appointed a dedicated account manager as a single point of contact for all procurement requests, replacements, and support escalations.',
        'Provided 1-year device warranty with SLA-backed turnaround commitments, ensuring minimal downtime for remote employees.',
      ],
      outcomes: [
        'All laptops delivered to Kaynes, Mysuru HQ in a single, fully-configured batch — enabling smooth last-mile distribution to remote employees without any vendor coordination overhead.',
        'Kaynes remote workforce experienced minimal downtime — faulty devices were returned to HQ and resolved swiftly, keeping employees productive from homeSeamless multi-site implementation at CGS\'s Hyderabad operations with no delays.',
        'Kaynes gained a long-term trusted IT partner with a dedicated account manager — replacing unreliable ad-hoc vendors with a structured, accountable relationship.',
        'Zero unresolved hardware issues — the HQ-centric support model ensured every faulty device was repaired on-site by a NewJaisa technician with no delays.',
        'Dedicated model numbers on every device gave Kaynes full hardware traceability — making warranty claims and support tickets faster and completely friction-free.',
        '1-year SLA-backed device warranty provided Kaynes full operational peace of mind — every device protected, every issue covered, with no hidden conditions',
      ],
      quote:     '"Managing laptops for a fully remote team across India felt impossible until NewJaisa stepped in. Delivering everything to our Mysuru HQ and sending a technician whenever we needed support was exactly the kind of structured, reliable partnership we were looking for. We finally have a vendor we can count on."',
      quoteName: 'IT Head — Kaynes Technology Limited',
      quoteRole: 'Electronics Manufacturing · Mysuru, Karnataka',
      ctaMsg:    'Want results like Kaynes Technology Limited?',
    },


    {
      id:            'Shakti Pumps',
      company:       'Shakti Pumps',
      logo:          'SP',
      subtitle:      'Manufacturing · Remote IT Reliability',
      industry:      'industrial-manufacturing',
      industryLabel: 'Manufacturing · Pan-India Distributed Hubs',
      pill:          '📖 Case Study · Manufacturing · Remote IT Reliability',
      tags:          ['Quality-First', '100+ uptime', 'Remote-support', 'Lifecycle Coverage'],
      desc:          'Shakti Pumps replaced erratic local supply channels across remote manufacturing hubs with NewJaisa\'s enterprise-grade refurbished hardware framework — putting quality, accountability, and borderless support above rock-bottom pricing.',
      metrics: [
        { num: '100%',       lbl: 'IT Reliability Achieved', cls: 'green' },
        { num: '1',  lbl: 'Accountable Coporate Partner',   cls: 'green' },
        { num: '0',        lbl: 'Unresolved Issues',           cls: 'green' },
        { num: 'Pan-India',  lbl: 'Remote Hub Coverage',  cls: 'green' },
        { num: 'Green', lbl: 'Supplu Chain Delay\'s Post-Switch',       cls: 'yellow' },
      ],
      challenge: [
        'Shakti Pumps replaced erratic local supply channels across remote manufacturing hubs with NewJaisa\'s enterprise-grade refurbished hardware framework — putting quality, accountability, and borderless support above rock-bottom pricing.',
        'Bargain-basement pricing meant cut corners — low-quality hardware directly correlated with lost man-hours and delayed supply chains across remote hubs.',
        'Managing multiple regional repair agents and unorganised local suppliers left Shakti Pumps\'s IT team with zero single point of accountability.',
        'Saving a few thousand rupees on procurement was irrelevant when frequent system crashes and missing supplier accountability were the cost.',
      ],
      solution: [
        'Supplied top-tier, rigorously audited commercial-grade laptops — each device passed an intensive multi-point diagnostics matrix before deployment.',
        'Deployed pan-India service infrastructure capable of dispatching technical assistance and replacement components to the most isolated manufacturing units.',
        'Replaced all regional repair fragmentation with a single, highly accountable corporate partner taking end-to-end ownership of the hardware lifecycle.',
        'Delivered predictable warranties, transparent asset tracking, and streamlined communication channels for Shakti Pumps\' centralised IT team.',
      ],
      outcomes: [
        'Hardware-related delays at scattered warehouse facilities dropped dramatically, keeping logistics and inventory tracking moving smoothly.',
        'Shakti Pumps\' IT division can now deploy assets to any remote corner of India, confident NewJaisa\'s support network covers them everywhere.',
        'Enterprise-grade diagnostics on every device meant zero DOA incidents — every laptop worked perfectly from day one.',
        'Steep drop in system failures and remote downtime created massive long-term savings — a far lower TCO than cheap alternatives.',
        'Single-partner accountability eliminated the chaos of multiple regional vendors — one call, one SLA, one responsible partner.',
        'Transparent asset tracking and predictable warranty cycles gave Shakti Pumps full fleet visibility for the first time across all distributed hubs.',
      ],
      quote:     '"We didn\'t choose NewJaisa because they were the cheapest. We chose them because they were the only vendor who could actually stand behind their hardware — at our Indore plant, at our Rajasthan warehouse, everywhere."',
      quoteName: 'Head of IT',
      quoteRole: 'Manufacturing Operations · Sakti Pumps',
      ctaMsg:    'Want results like Sakti Pumps?',
    },
    {
      id:            'Trent Ltd',
      company:       'Trent Ltd',
      logo:          'T',
      subtitle:      'Retail · Nationwide IT Consolidation',
      industry:      'retail',
      industryLabel: 'Retail Chain · Pan-India Operations',
      pill:          '📖 Case Study · Retail · Nationwide IT Consolidation',
      tags:          ['Unified Vendor', '200+ Units', 'On-Site Engineer', 'Buy-Back'],
      desc:          'Trent Ltd replaced a fragmented local vendor patchwork with NewJaisa\'s unified supply chain — securing enterprise-grade hardware, monthly on-site engineering, and a full-circle buy-back program across their nationwide retail network.',
      metrics: [
        { num: '200+',       lbl: 'Intial Units Deployed', cls: '' },
        { num: '500+',  lbl: 'Nationwide Rollout',   cls: '' },
        { num: '0',        lbl: 'Vendor Dispute Post-Switch',           cls: 'green' },
        { num: '1',  lbl: 'Trusted Vendor, Nation-wide',  cls: 'green' },
        { num: 'Monthly', lbl: 'On-Site Engineer visits',       cls: 'yellow' },
      ],
      challenge: [
        'Fragmented local vendor network created zero standardisation — hardware quality varied wildly from batch to batch across regions.',
        'Local vendors lacked the infrastructure for consistent after-sales service, leaving regional branches stranded during technical failures.',
        'Internal IT teams wasted critical time managing vendor disputes and chasing local technicians, causing severe operational downtime.',
        'No single point of accountability — each procurement cycle restarted the vetting process from scratch.',
      ],
      solution: [
        'Replaced the entire local vendor patchwork with a single, rigorously standardised enterprise supply chain.',
        'Leveraged NewJaisa\'s national support network to guarantee fast turnaround at every Trent facility, regardless of location.',
        'Introduced a dedicated monthly on-site engineer model to proactively prevent IT disruptions at Trent\'s core facilities.',
        'Structured a comprehensive asset buy-back program covering both Trent\'s legacy inventory and all newly supplied hardware.',
      ],
      outcomes: [
        'Secured a seamless 200-unit initial deployment, paving the way for a 500+ unit nationwide rollout.',
        'Standardised infrastructure replaced patchwork sourcing — same hardware spec, same quality, across every Trent location.',
        'Full-circle buy-back program guaranteed monetisation of both legacy and current assets through a single, trusted partner.',
        'Proactive monthly on-site engineering and national service footprint dropped technical delays to an all-time low.',
        'Trent\'s IT team reclaimed hours previously lost to vendor management — now focused entirely on internal operations.',
        'Certified data wipe and e-waste compliance on legacy assets resolved Trent\'s IT disposal liability entirely.',
      ],
      quote:     '"NewJaisa didn\'t just fix our hardware problem — they fixed our vendor problem. For the first time, we have a single partner we can actually call and trust, no matter which city we\'re operating in."',
      quoteName: 'Head of IT Infrastructure — Trent Ltd.',
      quoteRole: 'Retail operations · Trent Ltd.',
      ctaMsg:    'Want results like Trent Ltd.?',
    },
  ];

  /* ══════════════════════════════════════════════════
     ROUTER
  ══════════════════════════════════════════════════ */
  function showHub() {
    $('cs-view-hub').classList.add('cs-active');
    $('cs-view-detail').classList.remove('cs-active');
    document.title = 'Case Studies — NewJaisa Enterprise';
    window.scrollTo({ top: 0, behavior: 'instant' });
    currentStudy = null;
    setTimeout(initReveal, 60);
  }

  function showDetail(id) {
    var study = STUDIES.find(function (s) { return s.id === id; });
    if (!study) return;

    currentStudy = id;
    buildDetail(study);

    $('cs-view-hub').classList.remove('cs-active');
    $('cs-view-detail').classList.add('cs-active');
    if ($('cs-bc-name')) $('cs-bc-name').textContent = study.company;
    document.title = study.company + ' Case Study — NewJaisa Enterprise';
    window.scrollTo({ top: 0, behavior: 'instant' });
    setTimeout(initReveal, 60);
  }

  /* ══════════════════════════════════════════════════
     BUILD HUB CARDS
  ══════════════════════════════════════════════════ */
  function buildHubCards() {
    var grid = $('cs-hub-grid');
    if (!grid) return;

    grid.innerHTML = STUDIES.map(function (s) {
      var m3 = s.metrics.slice(0, 3);
      return '<div class="cs-hub-card cs-reveal" data-industry="' + s.industry + '" data-id="' + s.id + '">' +
        '<div class="cs-chc-head">' +
          '<div class="cs-chc-industry">' + s.industryLabel + '</div>' +
          '<div class="cs-chc-logo">'     + s.logo + '</div>' +
          '<div class="cs-chc-company">'  + s.company + '</div>' +
          '<div class="cs-chc-subtitle">' + s.subtitle + '</div>' +
          '<div class="cs-chc-tags">' + s.tags.map(function (t) {
            return '<span class="cs-chc-tag">' + t + '</span>';
          }).join('') + '</div>' +
        '</div>' +
        '<div class="cs-chc-metrics">' + m3.map(function (m) {
          return '<div class="cs-chcm-item">' +
            '<div class="cs-chcm-num">' + m.num + '</div>' +
            '<div class="cs-chcm-lbl">' + m.lbl + '</div>' +
          '</div>';
        }).join('') + '</div>' +
        '<div class="cs-chc-body">' +
          '<div class="cs-chc-summary">' + s.desc + '</div>' +
          '<div class="cs-chc-cta">Read Full Case Study →</div>' +
        '</div>' +
      '</div>';
    }).join('');

    /* Card click events */
    $$('.cs-hub-card').forEach(function (card) {
      card.addEventListener('click', function () {
        showDetail(card.getAttribute('data-id'));
      });
    });
  }

  /* ══════════════════════════════════════════════════
     BUILD DETAIL VIEW
  ══════════════════════════════════════════════════ */
  function buildDetail(s) {
    var set = function (id, val) { var el = $(id); if (el) el.textContent = val; };
    var html = function (id, val) { var el = $(id); if (el) el.innerHTML = val; };

    set('cs-bc-name',      s.company);
    set('cs-dh-pill',      s.pill);
    set('cs-dh-logo',      s.logo);
    set('cs-dh-company',   s.company);
    set('cs-dh-subtitle',  s.subtitle);
    set('cs-dh-desc',      s.desc);
    set('cs-quote-text',   s.quote);
    set('cs-quote-name',   s.quoteName);
    set('cs-quote-role',   s.quoteRole);
    set('cs-detail-cta-msg', s.ctaMsg);

    /* Stats */
    var grid = $('cs-ds-grid');
    if (grid) {
      grid.style.gridTemplateColumns = 'repeat(' + s.metrics.length + ',1fr)';
      grid.innerHTML = s.metrics.map(function (m) {
        return '<div class="cs-ds-item">' +
          '<div class="cs-ds-num' + (m.cls ? ' ' + m.cls : '') + '">' + m.num + '</div>' +
          '<div class="cs-ds-lbl">' + m.lbl + '</div>' +
        '</div>';
      }).join('');
    }

    /* Challenge */
    html('cs-challenge-list', s.challenge.map(function (c) {
      return '<li><span class="cs-li-icon">✗</span>' + c + '</li>';
    }).join(''));

    /* Solution */
    html('cs-solution-list', s.solution.map(function (c) {
      return '<li><span class="cs-li-icon">✓</span>' + c + '</li>';
    }).join(''));

    /* Outcomes */
    html('cs-outcomes-grid', s.outcomes.map(function (o) {
      return '<div class="cs-outcome-item">' +
        '<span class="cs-outcome-icon">✅</span>' +
        '<div class="cs-outcome-text">' + o + '</div>' +
      '</div>';
    }).join(''));

    /* More studies */
    var others = STUDIES.filter(function (x) { return x.id !== s.id; }).slice(0, 4);
    var moreGrid = $('cs-more-grid');
    if (moreGrid) {
      moreGrid.innerHTML = others.map(function (o) {
        return '<div class="cs-more-card" data-id="' + o.id + '">' +
          '<div class="cs-mc-logo">' + o.logo + '</div>' +
          '<div><div class="cs-mc-company">' + o.company + '</div>' +
          '<div class="cs-mc-sub">' + o.industryLabel + '</div></div>' +
          '<div class="cs-mc-arrow">→</div>' +
        '</div>';
      }).join('');

      $$('.cs-more-card').forEach(function (card) {
        card.addEventListener('click', function () {
          showDetail(card.getAttribute('data-id'));
        });
      });
    }
  }

  /* ══════════════════════════════════════════════════
     FILTER
  ══════════════════════════════════════════════════ */
  function initFilter() {
    $$('.cs-filter-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var tag = btn.getAttribute('data-filter') || 'all';
        $$('.cs-filter-btn').forEach(function (b) { b.classList.remove('cs-active'); });
        btn.classList.add('cs-active');

        var cards = $$('.cs-hub-card');
        var visible = 0;
        cards.forEach(function (card) {
          var show = tag === 'all' || card.getAttribute('data-industry') === tag;
          card.style.display = show ? '' : 'none';
          if (show) visible++;
        });

        var empty = $('cs-empty');
        if (empty) empty.style.display = visible === 0 ? 'block' : 'none';
      });
    });
  }

  /* ══════════════════════════════════════════════════
     SCROLL REVEAL
  ══════════════════════════════════════════════════ */
  function initReveal() {
    var els = $$('.cs-reveal:not(.cs-visible)');
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('cs-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var parent   = entry.target.parentElement;
        var siblings = parent
          ? Array.from(parent.children).filter(function (el) {
              return el.classList.contains('cs-reveal') && !el.classList.contains('cs-visible');
            })
          : [];
        var idx = siblings.indexOf(entry.target);
        setTimeout(function () { entry.target.classList.add('cs-visible'); }, Math.max(0, idx * 80));
        io.unobserve(entry.target);
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  /* ══════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════ */
  function init() {
    buildHubCards();
    showHub();
    initFilter();

    /* Breadcrumb back button */
    var bcBack = $('cs-bc-back');
    if (bcBack) bcBack.addEventListener('click', showHub);

    /* "View All Case Studies" button in detail more section */
    var backAll = $('cs-back-all');
    if (backAll) backAll.addEventListener('click', showHub);
  }

  return { init: init, showDetail: showDetail, showHub: showHub };

})();

document.addEventListener('DOMContentLoaded', function () {
  CaseStudies.init();
});
